import React, { useEffect, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import the styles
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  ViberShareButton,
  FacebookMessengerShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  FacebookIcon,
  EmailIcon,
  FacebookMessengerIcon,
  TelegramIcon,
  ViberIcon,
  WhatsappIcon,
} from "react-share";

function Pomen({ post, modalIsOpen }) {
  const userRole = localStorage.getItem("userRole");
  const [imageSrc, setImageSrc] = useState(require("../assets/candle.png"));
  const [counter, setCounter] = useState(post.counter);

  const handleCandleClick = async () => {
    // Toggle between two image sources
    if (imageSrc === require("../assets/candle.png")) {
      setImageSrc(require("../assets/candleColor.png"));
    } else {
      setImageSrc(require("../assets/candle.png"));
    }

    try {
      await increaseCounter();
    } catch (error) {
      console.log("Error updating counter:", error);
    }
  };

  const increaseCounter = async () => {
    try {
      await axios.post(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}/counter/up/`,
        {}
      );
      setCounter(post.counter + 1);
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  if (counter === null) {
    return <div>No pomen posts available.</div>;
  }

  const deletePosts = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.delete(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      window.location.href = "/";
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const modalStyle = {
    border: "7px double black",
    backgroundColor: "white",
    height: "320px",
  };

  return (
    <Container
      data-aos="fade-up"
      className="post"
      id="pomen"
      style={modalIsOpen ? { ...modalStyle, height: "auto" } : modalStyle}
    >
      {" "}
      <Row>
        <p
          style={{
            fontStyle: "italic",
            border: "none",
            borderTop: "none",
            textAlign: "right",
            backgroundColor: "white",
            color: "gray",
          }}
        >
          {post.type === "poslednji_pozdrav" ? "poslednji pozdrav" : post.type}
        </p>
      </Row>
      <p style={{ padding: "1%", fontSize: "14px" }}>{post.text_top}</p>
      <Row>
        <Col className="d-flex justify-content-around"></Col>
        <Col className="d-flex justify-content-around">
          {post.images.length !== 0 && (
            <Carousel
              showThumbs={false}
              showArrows={false}
              infiniteLoop={true}
              autoPlay={true}
              interval={2500}
            >
              {post.images
                .reduce((p, c) => p + c)
                .split(",")
                .map((imagePath, index) => (
                  <div className="d-flex justify-content-center" key={index}>
                    <div
                      style={{
                        width: "110px",
                        height: "130px",
                        border: "3px solid black",
                        background: `url(https://radojicictijanaa.pythonanywhere.com/${imagePath})`,
                        backgroundSize: "cover",
                        backgroundPosition: "50% 50%",
                      }}
                    ></div>
                  </div>
                ))}
            </Carousel>
          )}

          {post.images.length === 0 && (
            <div
              style={{
                width: "140px",
                height: "140px",
              }}
            ></div>
          )}
        </Col>
        <Col className="d-flex justify-content-around"></Col>
      </Row>
      <Row style={{}}>
        <Col className="d-flex justify-content-around"></Col>
        <p
          style={{ fontWeight: "bold", letterSpacing: "1.2px" }}
          className="d-flex justify-content-around"
        >
          {post.name}
        </p>
        <Col className="d-flex justify-content-around"></Col>
      </Row>
      <Row>
        <p
          className="main-text"
          style={{ padding: "0%", fontSize: "12px", textAlign: "center" }}
        >
          {post.main_text}
        </p>
      </Row>
      {modalIsOpen && (
        <Row>
          {" "}
          <span style={{ textAlign: "center" }}>Upali svijeću</span>
        </Row>
      )}
      {modalIsOpen && (
        <Row>
          {" "}
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              alignItems: "center",
              borderRadius: "100%",
            }}
            onClick={handleCandleClick}
          >
            <img src={imageSrc} alt="Image" />
          </button>
        </Row>
      )}
      {modalIsOpen && (
        <Row style={{ paddingBottom: "0" }}>
          {" "}
          <span style={{ textAlign: "center" }}>{counter}</span>
        </Row>
      )}
      <Row style={{}}>
        <b>
          <p style={{ float: "right", fontSize: "15px" }}>{post.text_bottom}</p>
        </b>
      </Row>
      {modalIsOpen && (userRole === "admin" || userRole === "superadmin") && (
        <Col>
          <button className="btn btn-danger" onClick={() => deletePosts()}>
            Obriši
          </button>
        </Col>
      )}
      {modalIsOpen && (
        <div
          style={{ float: "right", paddingBottom: "2%", paddingRight: "1%" }}
        >
          <FacebookShareButton
            title="Facebook"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookShareButton>
          <span title="Viber">
            <ViberShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <ViberIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </ViberShareButton>
          </span>
          <EmailShareButton
            title="Email"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            subject="Check out this post"
          >
            <EmailIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </EmailShareButton>
          <FacebookMessengerShareButton
            title="Messenger"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookMessengerIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookMessengerShareButton>
          <span title="Telegram">
            <TelegramShareButton
              title="Telegram"
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <TelegramIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </TelegramShareButton>
          </span>
          <span title="What's App">
            <WhatsappShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
              title="Check out this post"
            >
              <WhatsappIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </WhatsappShareButton>
          </span>
        </div>
      )}
    </Container>
  );
}

export default Pomen;
